import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

import { ReactComponent as DateSvg } from "@/svgs/date.svg?react";

export default function DateIcon(props: SvgIconProps) {
	return <SvgIcon {...props} component={DateSvg} inheritViewBox />;
}
